export const NonNullable = <T>(c: T): c is NonNullable<typeof c> => Boolean(c)
